import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {DEF_INPUT_SIZE, getExpectedValueTypeDescription, VALUE_TYPE} from "../../enums/enums";
import {JP} from "../../helpers/jp";
import {canCast, castValue} from "../../utils";
import * as _ from "underscore";
import {WatchService} from "../../services/watch.service";
import {inputUtils} from "../../helpers/input-utils";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {Subject} from "rxjs/Subject";
import {isUndefined} from "util";

declare const $: any;


@Component({
  selector: "nv-input",
  templateUrl: "./nv-input.component.html"
})
export class NvInput implements OnInit, AfterViewInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject<void>();
  private lastNewDocumentEvent: INewDocumentEvent;

  //private _valueModel: any;
  private _pointer: string;
  private _document: any;
  private _hasValueError: boolean;
  private _label: string;
  private _optional: boolean = false;

  @Input() ignoreDocumentReadonlyFlag: boolean = false;
  @Input("val_type") valueType: VALUE_TYPE;
  @Input("hide_label") hideLabel: boolean;
  @Input("size") columnSize: number = DEF_INPUT_SIZE;
  @Input() multi: boolean = false;

  @Input() set label(v: string) {
    this._label = v;
  }

  @Input() set pointer(v: string) {
    this._pointer = v;
    this.updateModel();
  }

  @Input() set optional(v: boolean) {
    this._optional = v;
    this.updateModel();
  }

  @Input() set document(v: any) {
    this._document = v;
    this.updateModel();
  }

  get help() { return this._pointer; }
  get pointer() { return this._pointer; }
  get document() { return this._document; }
  get hasValueError(): boolean { return this._hasValueError; }
  get label() { return this._label || this.pointer; }
  get optional() {return this._optional; }
 // get valueModel() { return this._valueModel; }


  @ViewChild("inputNode") element: ElementRef;


  constructor(private watchService: WatchService,
              private busService: BusService) {
  }


  ngOnInit() {
    this.busService
      .onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(e => this.onDocumentUpdated(e));
  }


  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  ngAfterViewInit(): void {
    this.updateNodeState();
  }

  onValueChange(value: string) {
    this._hasValueError = !canCast(value, this.valueType);
    if (this._optional && value === "") {
      JP.remove(this.document, this.pointer);
    }
    else {
      JP.set(this.document, this.pointer, castValue(value, this.valueType));
    }

    this.updateModel();
    this.watchService.notify();
  }

  getValueModel(){
    if (_.isUndefined(this.document) || _.isUndefined(this.pointer)) {
      return;
    }

    var result = inputUtils.getValueModelAndInitializeIfNecessary(this.document, this.pointer, this.valueType);

    if (this._hasValueError) {
      this._hasValueError = !canCast(result, this.valueType);
      if (!this._hasValueError)
      {
        this.hidePopover();
      }
    }
    return result;
  }

  setValueModel(){
    this.updateModel();
  }
h

  private updateModel() {
    if (_.isUndefined(this.document) || _.isUndefined(this.pointer)) {
      return;
    }

    let value = this.getValueModel();
    let casted = canCast(value, this.valueType);
    this._hasValueError = (this._optional && !isUndefined(value) && !casted) || (!this._optional && !casted);

    if (this._hasValueError) {
      this.setUpPopoverAndShow();
    } else {
      this.hidePopover();
    }
  }


  private setUpPopoverAndShow() {
    const expectedValueDescription = getExpectedValueTypeDescription(this.valueType);
    if (!expectedValueDescription) {
      return;
    }

    if (this.element && this.element.nativeElement) {
      $(this.element.nativeElement)
        .popover({
          content: expectedValueDescription,
          trigger: "manual",
          placement: "top"
        });
      $(this.element.nativeElement).popover("show");
    }
  }

  private hidePopover() {
    if (this.element && this.element.nativeElement) {
      $(this.element.nativeElement).popover("hide");
    }
  }


  private onDocumentUpdated(e: INewDocumentEvent) {
    this.lastNewDocumentEvent = e;
    this.updateNodeState();
  }


  private updateNodeState() {
    if (this.ignoreDocumentReadonlyFlag) { return; }
    if (!this.element) { return; }

    if (this.lastNewDocumentEvent.readonly) {
      $(this.element.nativeElement).prop("disabled", true);
    } else {
      $(this.element.nativeElement).prop("disabled", false);
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-input/nv-input.component.ts